var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34486 7.83256V5.87442C3.34486 3.17079 5.53659 0.979065 8.24022 0.979065C10.9438 0.979065 13.1356 3.17079 13.1356 5.87442V7.83256C14.217 7.83256 15.0937 8.70925 15.0937 9.7907V14.6861C15.0937 15.7675 14.217 16.6442 13.1356 16.6442H3.34486C2.26341 16.6442 1.38672 15.7675 1.38672 14.6861V9.7907C1.38672 8.70925 2.26341 7.83256 3.34486 7.83256ZM11.1774 5.87442V7.83256H5.303V5.87442C5.303 4.25224 6.61804 2.93721 8.24022 2.93721C9.86239 2.93721 11.1774 4.25224 11.1774 5.87442Z",
    fill: "#3083DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.690505 0.692308C1.07286 0.309957 1.91417 0.531354 2.56963 1.18681L16.8114 15.4286C17.4668 16.084 17.6882 16.9253 17.3059 17.3077C16.9235 17.69 16.0822 17.4686 15.4268 16.8132L1.18501 2.57143C0.529552 1.91597 0.308154 1.07466 0.690505 0.692308Z",
    fill: "#3083DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/Unlocked.8f61428e7954399dbd9d7c70e20694dc.svg";
export { ForwardRef as ReactComponent };